import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { GetStaticPaths } from "next";
import Head from "next/head";
import { LoginWidget } from "@components/okta/LoginWidget";
import { prefixWithBasePath } from "../../lib/asset";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

export default function LoginPage() {
  const { t } = useTranslation(["common", "login"]);
  return (
    <>
      <Head>
        <title>{`myCargill - ${t("login:login.title")}`}</title>
        <meta
          name="description"
          content={t("login:login.title") || undefined}
        />
      </Head>
      <Box
        sx={{
          flex: 1,
          backgroundImage: `url(${prefixWithBasePath(
            "/assets/images/mycargill-landing.webp"
          )})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
        }}
      >
        <Container
          sx={{
            minHeight: "670px",
            padding: `40px 12px`,
            display: "flex",
            gap: { lg: 20, md: 10, sm: 4 },
            justifyContent: "center",
            alignItems: "center",
            mb: 16,
          }}
        >
          <LoginWidget />
        </Container>
      </Box>
    </>
  );
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export const getStaticProps = async ({ locale }: any) => {
  return {
    props: {
      // even though OktaSignInWidget is dynamically imported
      // you must include `login` so that its translations are available for its internal use
      // otherwise you will see `login:login.xyz` missing strings or errors
      ...(await serverSideTranslations(locale, ["login", "common", "welcome"])),
    },
  };
};
